<template>
  <Pie :chart-data="data" :chart-options="options" />
</template>

<script>
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Pie } from 'vue-chartjs'

ChartJS.register(ArcElement, Tooltip, Legend)

export default {
  props: {
    data: Object,
    options: Object,
  },
  
  data: () => ({}),
  components: {
    Pie
  },
}
</script>